// extracted by mini-css-extract-plugin
module.exports = {"coachmarkContent":"AddressPrompt_coachmarkContent__1y7Bo","crossIcon":"AddressPrompt_crossIcon__Az6IN"};